exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "label {\r\n    text-align: right;\r\n    width: 80px;\r\n}\r\n\r\n.txtInput {\r\n    width: 240px;\r\n}\r\n\r\n.table-tecni thead tr th {\r\n    background-color: #A14950;\r\n    border: 1px solid #A14950;\r\n    color: #ffffff;\r\n}\r\n\r\n.table-tecni-gray thead tr th {\r\n    background-color: #808284;\r\n    border: 1px solid #808284;\r\n    color: #ffffff;\r\n}\r\n\r\n.selectAccesorio {\r\n    width: 184px !important;\r\n}\r\n\r\n.textoBoton {\r\n    font-size: 12px;\r\n}\r\n.tabTecni .nav-tabs li.active a {\r\n    color: #A14950;\r\n    background-color: #EDEDED;\r\n}\r\n.titulo-table{\r\ntext-align: center;\r\n}\r\n.labelBeneficiario{\r\n    width: 150px;\r\n}\r\n\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/masivos/segurosContratados/seguros-contratados.style.css
// module id = ../../../../../src/app/views/masivos/segurosContratados/seguros-contratados.style.css
// module chunks = 0